import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	makeStyles, Tooltip, TextField, Typography, CircularProgress
} from '@material-ui/core';
//icons
import React, { useState } from 'react';
import { useActions, useValues } from 'kea';
import VpnKeyIcon from '@material-ui/icons/VpnKey'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
} from '@material-ui/core'
import TableContainer from "@material-ui/core/TableContainer"

import keylogic from 'src/store/key';

const useStyles = makeStyles((theme) => ({
	paper: {
		maxWidth: '200px'
	},
}));



const withTooltip = (text) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden'
		}}>
			{text}
		</div>
	</Tooltip >
)

let columns = [
	{
		field: "id",
		align: "left",
		headerName: "ID",
		width: 150,
	},
	{
		field: "name",
		align: "left",
		headerName: "Name",
		width: 100,
	},
	{
		field: "edit", //good or bad
		align: "left",
		headerName: "New name",
		width: 100,
	},
]

const Keyname = ({ row }) => {
	const [name, setName] = useState(row.name);
	const { rename } = useActions(keylogic);
	const handleRename = () => {
		rename({
			_id: row._id,
			name: name
		})
	}
	return (
		<div style={{
			display: 'flex',
			flexGrow: '1',
		}}>
			<TextField size='small' variant="outlined" onChange={e => setName(e.target.value)} value={name}></TextField>
			<Button color="primary" variant="outlined" onClick={handleRename}>Save</Button>
		</div>
	)
}

const RenameKeyDialog = () => {
	const classes = useStyles();

	const [open, setOpen] = useState(false);
	const { keys } = useValues(keylogic);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);


	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const handleChangePage = (_even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	if (keys === null) return <CircularProgress />
	const emptyRows = rowsPerPage - Math.min(rowsPerPage, keys.length - page * rowsPerPage);

	return (
		<div style={{ paddingTop: '15px' }}>
			<Tooltip title='Rename Keys'>
				<Button
					color="primary"
					size="large"
					variant="contained"
					aria-label="add"
					onClick={handleClickOpen}
					startIcon={<VpnKeyIcon />}
				>
					Rename Keys
				</Button>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth='s'
				// style={{ maxWidth: '300px' }}
				className={{
					paperWidthXs: classes.paper
				}}
			>
				<DialogTitle id="form-dialog-title">
					Rename Keys
					<Typography align="center" color="secondary">You need to have Driver Identification setup for your vehicles.</Typography>
				</DialogTitle>
				<DialogContent>
					<div style={{ height: '100%', width: '100%', background: 'white' }}>
						<TableContainer className={classes.container}>
							<Table stickyHeader aria-label="sticky table" size={'small'}>
								<TableHead>
									<TableRow>
										{columns.map((column) => (
											<TableCell
												key={column.field}
												align={column.align}
												style={{ minWidth: column.width }}
											>
												{column.headerName}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody>
									{
										keys && keys.length > 0 ?
											keys
												.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
												.map((row, index) => {
													return (
														<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
															{columns.map((column) => {
																if (column.field === 'edit') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				<Keyname row={row} />
																			</TableCell>
																		</>
																	)
																}
																const value = row[column.field];
																return (
																	<TableCell key={column.field} align={column.align}>
																		{column.format && typeof value === "number"
																			? column.format(value)
																			: value}
																	</TableCell>
																);
															})}
														</TableRow>
													);
												})
											: <TableRow>
												<TableCell style={{ height: 61 * rowsPerPage }} colSpan={5} align={'center'}>
													No Data Added.
												</TableCell>
											</TableRow>
									}
									{
										keys.length > 0 && emptyRows > 0 && (
											<TableRow style={{ height: 61 * emptyRows }}>
												<TableCell colSpan={6} />
											</TableRow>
										)
									}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[10]}
							component="div"
							count={keys ? keys.length : 0}
							rowsPerPage={rowsPerPage}
							page={page}
							onChangePage={handleChangePage}
							onChangeRowsPerPage={handleChangeRowsPerPage}
						/>

					</div>
				</DialogContent>
				<DialogActions>
				</DialogActions>
			</Dialog>
		</div>
	)
}


export default RenameKeyDialog
